export default __webpack_public_path__ + "static/media/backend-nodejs.06c7fba2.png";